import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { toTitleCase } from "../../../../../utils";

const getMapSubmissionData = (t, id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const edcrData = Digit.SessionStorage.get("EDCR_CREATE")?.[0];
  const fastPasData = Digit.SessionStorage.get("FASTPAS_ID");
  console.log("edcrdatafrommapsubportal", edcrData, fastPasData);

  const planDetail = edcrData?.planDetail;
  const regulatedObj = edcrData?.planDetail?.reportOutput?.scrutinyDetails?.filter((e) => e.key === "Block_1_Side Setback");
  const { isSuccess: isMdmsSuccess, data: mdmsData } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["RiskTypeComputation"]);
  const calcRiskType =
    isMdmsSuccess && Digit.Utils.obps.calculateRiskType(mdmsData?.BPA?.RiskTypeComputation, planDetail?.plot?.area, planDetail?.blocks);
  const riskType = calcRiskType ? t(`WF_BPA_${calcRiskType}`) : null;
  const scrutinyDetails = Digit.SessionStorage.get("ScrutinyDetails");
  const blocks = planDetail?.blocks?.[0];
  const setBacksData = blocks?.setBacks?.[0];
  const planInformation = planDetail?.planInformation;

  console.log("PlanInformation2333", planInformation);

  const fetchApplicationData = async () => {
    return await Digit.OBPSService.BPASearch(tenantId, { applicationId: id, isEmployee: false });
  };
  const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData, enabled: isMdmsSuccess });
  // let applicationData = isSuccess && data?.BPA?.[0];
  let applicationData = data?.BPA?.[0] || {};

  const isRescrutiny = applicationData?.drawingDetail?.length > 0;
  console.log("ApplicationData31313", edcrData, applicationData, fastPasData);
  // if (id && !isRescrutiny)
  if (id && isSuccess && !isRescrutiny) {
    console.log("I am here 4778");
    // Fetch application data for edit flow
    applicationData = {
      ...applicationData,

      applicationDate: edcrData?.applicationDate || applicationData?.applicationDate || null,
      occupancy: planInformation?.occupancy || applicationData?.occupancy || null,
      edcrNumber: edcrData?.edcrNumber || applicationData?.edcrNumber || null,

      totalBuildUpArea: applicationData?.totalBuildUpArea || planDetail?.virtualBuilding?.totalBuitUpArea,

      totalProposedArea: planDetail?.virtualBuilding?.totalProposedArea || applicationData?.totalProposedArea,

      totalExistingBuiltUpArea: planDetail?.virtualBuilding?.totalExistingBuiltUpArea || applicationData?.totalExistingBuiltUpArea,

      maximumPermissibleGroundCoverage:
        planDetail?.virtualBuilding?.totalCoverageArea?.toFixed(2) || applicationData?.maximumPermissibleGroundCoverage || null,

      typeofArea: toTitleCase(planInformation?.landUseZone) || applicationData?.typeofArea,

      propertyType:
        toTitleCase(planInformation?.applicantPropertyType || planDetail?.planInfoProperties?.PROPERTY_TYPE) || applicationData?.propertyType,

      revenueVillageMohal: planInformation?.mauza || applicationData?.revenueVillageMohal || null,

      khataNo: planInformation?.khataNo || applicationData?.khataNo || null,

      khatauniNo: planInformation?.khatauniNo || applicationData?.khatauniNo || null,

      plotArea: planInformation?.plotArea || planDetail?.plot?.area || applicationData?.plotArea || 0,
      viewPdf: edcrData?.viewPdf,
      viewPlanReport: edcrData?.viewPlanReport,
      totalPlotArea: planInformation?.plotArea || applicationData?.totalPlotArea || 0,

      blocks: planDetail?.blocks || applicationData?.blocks || null,

      noOfBlocks: planDetail?.blocks?.length || applicationData?.noOfBlocks || 0,

      premiumFAR: planDetail?.virtualBuilding?.premiumFarArea || applicationData?.premiumFAR || 0,

      demolitionArea: planInformation?.demolitionArea || applicationData?.demolitionArea || null,

      parkingArea: planDetail?.parkingDetails?.overAllParkingArea || applicationData?.parkingArea || 0,

      parkingFloorNo: planDetail?.parkingDetails?.parkingFloorNo || applicationData?.parkingFloorNo || 0,

      activeTab: Digit?.SessionStorage.get("MS_CURRENT_TAB") || applicationData?.activeTab || 0,

      riskType: edcrData?.riskType || applicationData?.riskType,

      planReport: edcrData?.planReport || applicationData?.planReport,

      updatedDxfFile: edcrData?.updatedDxfFile || applicationData?.updatedDxfFile,

      dxfFile: edcrData?.dxfFile || applicationData?.dxfFile,

      natureOfConstruction: edcrData?.natureOfConstruction || applicationData?.natureOfConstruction,

      proposalType: edcrData?.proposalType || applicationData?.proposalType,

      sanctionDate: edcrData?.sanctionDate || applicationData?.sanctionDate,

      sanctionNumber: edcrData?.sanctionNumber || applicationData?.sanctionNumber,

      noOfPlots: edcrData?.noOfPlots || applicationData?.noOfPlots,

      plotNumbers: edcrData?.plotNumbers || applicationData?.plotNumbers,

      district: edcrData?.district || applicationData?.district,

      sectorNoPlotNo: edcrData?.sectorNoPlotNo || applicationData?.sectorNoPlotNo,

      tehsil: edcrData?.tehsil || applicationData?.tehsil,

      revenueVillage: edcrData?.revenueVillage || applicationData?.revenueVillage,

      landMark: edcrData?.landMark || applicationData?.landMark,

      schemeName: edcrData?.schemeName || applicationData?.schemeName,

      buildingClassification: edcrData?.buildingClassification || applicationData?.buildingClassification,

      otherbuildingClass: edcrData?.otherbuildingClass || applicationData?.otherbuildingClass,

      planOn: edcrData?.planOn || applicationData?.planOn,

      buildingHeight: edcrData?.buildingHeight || applicationData?.buildingHeight,

      projectType: edcrData?.projectType || applicationData?.projectType,

      isRevised: edcrData?.isRevised || applicationData?.isRevised,

      prevFileNo:
        edcrData?.prevFileNo ||
        applicationData?.prevFileNo ||
        applicationData?.mapSubDetails?.prevFileNo ||
        applicationData?.additionalDetails?.oldCaseApplicationNo ||
        null,

      sanctionValidityDate:
        edcrData?.sanctionValidityDate ||
        applicationData?.sanctionValidityDate ||
        applicationData?.mapSubDetails?.sanctionValidityDate ||
        edcrData?.mapSubDetails?.sanctionValidityDate ||
        null,

      sanctionValidityStartDate:
        edcrData?.sanctionValidityStartDate ||
        applicationData?.sanctionValidityStartDate ||
        applicationData?.mapSubDetails?.sanctionValidityStartDate ||
        edcrData?.mapSubDetails?.sanctionValidityStartDate ||
        null,

      isSpecialProject: edcrData?.isSpecialProject || applicationData?.isSpecialProject,

      typeOfProject: edcrData?.typeOfProject || applicationData?.typeOfProject,

      plotSubdivided: edcrData?.plotSubdivided || applicationData?.plotSubdivided,

      plotNo: edcrData?.plotNo || applicationData?.plotNo,

      isGovernmentBuilding: edcrData?.isGovernmentBuilding || applicationData?.isGovernmentBuilding,

      needCompounding: edcrData?.needCompounding || applicationData?.needCompounding,

      plotLeaseHold: edcrData?.plotLeaseHold || applicationData?.plotLeaseHold,

      isApprovedLayout: edcrData?.isApprovedLayout || applicationData?.isApprovedLayout,

      isSpecialGroundCoverage: edcrData?.isSpecialGroundCoverage || applicationData?.isSpecialGroundCoverage,

      isSpecialFAR: edcrData?.isSpecialFAR || applicationData?.isSpecialFAR,

      constructionType: edcrData?.constructionType || applicationData?.constructionType,

      layoutsanctionNumber: edcrData?.layoutsanctionNumber || applicationData?.layoutsanctionNumber,

      layoutsanctionDate: edcrData?.layoutsanctionDate || applicationData?.layoutsanctionDate,

      groundCoverage: edcrData?.groundCoverages || applicationData?.groundCoverage,

      far: edcrData?.fars || applicationData?.far,

      isSetbackRequired: edcrData?.isSetbackRequired || applicationData?.isSetbackRequired,

      setbackFronts: edcrData?.previousSetbackFront || applicationData?.setbackFronts,

      setbackRears: edcrData?.previousSetbackRear || applicationData?.setbackRears,

      setbackSide1: edcrData?.previousSetbackSide1 || applicationData?.setbackSide1,

      setbackSide2: edcrData?.previousSetbackSide2 || applicationData?.setbackSide2,

      zoneType: edcrData?.zoneType || applicationData?.zoneType,

      isMetroCity: edcrData?.isMetroCity || applicationData?.isMetroCity,

      subZoneType: edcrData?.subZoneType || applicationData?.subZoneType,

      primaryUse: edcrData?.primaryUse || applicationData?.primaryUse,

      activityProposed: edcrData?.activityProposed || applicationData?.activityProposed,

      communityParking: edcrData?.communityParking || applicationData?.communityParking,

      anyotherCondition: edcrData?.anyotherCondition || applicationData?.anyotherCondition,

      khasraNo: edcrData?.khasraNo || applicationData?.khasraNo,

      sectorNo: edcrData?.sectorNo || applicationData?.sectorNo,

      fastPASId: fastPasData?.land_Id || applicationData?.fastPASId,

      schemeType: fastPasData?.descriptionOfLand?.schemeType || applicationData?.schemeType,

      typeOfArea: fastPasData?.descriptionOfLand?.developmentArea || applicationData?.typeOfArea,

      latitude: fastPasData?.descriptionOfLand?.latitude || applicationData?.latitude,

      longitude: fastPasData?.descriptionOfLand?.longitude || applicationData?.longitude,
      latitude: fastPasData?.descriptionOfLand?.latitude || applicationData?.latitude,

      roadwidth: fastPasData?.descriptionOfLand?.roadWidths?.[0]?.value || applicationData?.roadwidth,

      approachRoadWidth: fastPasData?.descriptionOfLand?.approachRoadWidths?.[0]?.value || applicationData?.approachRoadWidth,

      khasraDetails: fastPasData?.khasraDetails || applicationData?.khasraDetails,
      scrutinyFlow: applicationData?.scrutinyFlow || (edcrData?.edcrNumber && "EDCR"),

      selectedCity: fastPasData?.selectedCity || applicationData?.selectedCity,

      selectedUnit: fastPasData?.selectedUnit || applicationData?.selectedUnit,

      schemeName: edcrData?.schemeName || fastPasData?.schemeName || applicationData?.schemeName,

      mapSubDetails: {
        ...applicationData?.mapSubDetails,
        ...edcrData?.mapSubDetails,
        proposalTypeFAR: edcrData?.mapSubDetails?.proposalTypeFAR || applicationData?.mapSubDetails?.proposalTypeFAR,
        landUseApprovalLetter: edcrData?.mapSubDetails?.landUseApprovalLetter || applicationData?.approvalLetterUrl || fastPasData?.approvalLetterUrl,
        fireFighting: edcrData?.mapSubDetails?.fireFighting || applicationData?.mapSubDetails?.fireFighting,
        prevFileNo:
          edcrData?.prevFileNo ||
          applicationData?.prevFileNo ||
          applicationData?.mapSubDetails?.prevFileNo ||
          edcrData?.mapSubDetails?.prevFileNo ||
          applicationData?.additionalDetails?.oldCaseApplicationNo ||
          null,
        sanctionValidityDate:
          edcrData?.sanctionValidityDate ||
          applicationData?.sanctionValidityDate ||
          applicationData?.mapSubDetails?.sanctionValidityDate ||
          edcrData?.mapSubDetails?.sanctionValidityDate ||
          null,
        sanctionValidityStartDate:
          edcrData?.sanctionValidityStartDate ||
          applicationData?.sanctionValidityStartDate ||
          applicationData?.mapSubDetails?.sanctionValidityStartDate ||
          edcrData?.mapSubDetails?.sanctionValidityStartDate ||
          null,
      },

      descriptionOfLand: applicationData?.descriptionOfLand || fastPasData?.descriptionOfLand,
      // drawingDetail: [...applicationData?.drawingDetail, { viewPdf: edcrData?.viewPdf }],
      landInfo: fastPasData?.landInfo || applicationData?.landInfo,
      shelterFee: planInformation?.shelterFee || applicationData?.shelterFee || null,
      performanceGuarantee: edcrData?.additionalProperties?.performanceGuarantee || applicationData?.performanceGuarantee || null,
    };

    return { applicationData, isAppDataLoading };
  } else if (id && isSuccess && isRescrutiny) {
    console.log("I am here 218", planInformation);
    applicationData = {
      ...applicationData,

      applicationDate: edcrData?.applicationDate || applicationData?.applicationDate || null,
      occupancy: planInformation?.occupancy || applicationData?.occupancy || null,
      edcrNumber: edcrData?.edcrNumber || applicationData?.edcrNumber || null,

      totalBuildUpArea: planDetail?.virtualBuilding?.totalBuitUpArea || applicationData?.totalBuildUpArea,

      totalProposedArea: planDetail?.virtualBuilding?.totalProposedArea || applicationData?.totalProposedArea,

      totalExistingBuiltUpArea: planDetail?.virtualBuilding?.totalExistingBuiltUpArea || applicationData?.totalExistingBuiltUpArea,

      maximumPermissibleGroundCoverage:
        planDetail?.virtualBuilding?.totalCoverageArea?.toFixed(2) || applicationData?.maximumPermissibleGroundCoverage || null,

      typeofArea: toTitleCase(planInformation?.landUseZone) || applicationData?.typeofArea,

      propertyType:
        toTitleCase(planInformation?.applicantPropertyType || planDetail?.planInfoProperties?.PROPERTY_TYPE) || applicationData?.propertyType,

      revenueVillageMohal: planInformation?.mauza || applicationData?.revenueVillageMohal || null,

      khataNo: planInformation?.khataNo || applicationData?.khataNo || null,

      khatauniNo: planInformation?.khatauniNo || applicationData?.khatauniNo || null,
      purchasableFar: planInformation?.purchasableFar || applicationData?.purchasableFar || null,
      compensatoryFAR: planInformation?.compensatoryFAR || applicationData?.compensatoryFAR || null,
      transferredLandArea: planInformation?.transferredLandArea || applicationData?.transferredLandArea || null,

      plotArea: planInformation?.plotArea || planDetail?.plot?.area || applicationData?.plotArea || 0,
      viewPdf: edcrData?.viewPdf,
      viewPlanReport: edcrData?.viewPlanReport,
      totalPlotArea: planInformation?.plotArea || applicationData?.totalPlotArea || 0,

      blocks: planDetail?.blocks || applicationData?.blocks || null,

      noOfBlocks: planDetail?.blocks?.length || applicationData?.noOfBlocks || 0,

      premiumFAR: planDetail?.virtualBuilding?.premiumFarArea || applicationData?.premiumFAR || 0,

      demolitionArea: planInformation?.demolitionArea || applicationData?.demolitionArea || null,

      parkingArea: planDetail?.parkingDetails?.overAllParkingArea || applicationData?.parkingArea || 0,

      parkingFloorNo: planDetail?.parkingDetails?.parkingFloorNo || applicationData?.parkingFloorNo || 0,

      activeTab: Digit?.SessionStorage.get("MS_CURRENT_TAB") || applicationData?.activeTab || 0,

      riskType: edcrData?.riskType || applicationData?.riskType,

      planReport: edcrData?.planReport || applicationData?.planReport,

      updatedDxfFile: edcrData?.updatedDxfFile || applicationData?.updatedDxfFile,

      dxfFile: edcrData?.dxfFile || applicationData?.dxfFile,

      natureOfConstruction: edcrData?.natureOfConstruction || applicationData?.natureOfConstruction,

      proposalType: edcrData?.proposalType || applicationData?.proposalType,

      sanctionDate: edcrData?.sanctionDate || applicationData?.sanctionDate,

      sanctionNumber: edcrData?.sanctionNumber || applicationData?.sanctionNumber,

      noOfPlots: edcrData?.noOfPlots || applicationData?.noOfPlots,

      plotNumbers: edcrData?.plotNumbers || applicationData?.plotNumbers,

      district: edcrData?.district || applicationData?.district,

      sectorNoPlotNo: edcrData?.sectorNoPlotNo || applicationData?.sectorNoPlotNo,

      tehsil: edcrData?.tehsil || applicationData?.tehsil,

      revenueVillage: edcrData?.revenueVillage || applicationData?.revenueVillage,

      landMark: edcrData?.landMark || applicationData?.landMark,

      schemeName: edcrData?.schemeName || applicationData?.schemeName,

      buildingClassification: edcrData?.buildingClassification || applicationData?.buildingClassification,

      otherbuildingClass: edcrData?.otherbuildingClass || applicationData?.otherbuildingClass,

      planOn: edcrData?.planOn || applicationData?.planOn,

      buildingHeight: edcrData?.buildingHeight || applicationData?.buildingHeight,

      projectType: edcrData?.projectType || applicationData?.projectType,

      isRevised: edcrData?.isRevised || applicationData?.isRevised,

      prevFileNo:
        edcrData?.prevFileNo ||
        applicationData?.prevFileNo ||
        applicationData?.mapSubDetails?.prevFileNo ||
        applicationData?.additionalDetails?.oldCaseApplicationNo ||
        null,

      sanctionValidityDate:
        edcrData?.sanctionValidityDate ||
        applicationData?.sanctionValidityDate ||
        applicationData?.mapSubDetails?.sanctionValidityDate ||
        edcrData?.mapSubDetails?.sanctionValidityDate ||
        null,

      sanctionValidityStartDate:
        edcrData?.sanctionValidityStartDate ||
        applicationData?.sanctionValidityStartDate ||
        applicationData?.mapSubDetails?.sanctionValidityStartDate ||
        edcrData?.mapSubDetails?.sanctionValidityStartDate ||
        null,

      isSpecialProject: edcrData?.isSpecialProject || applicationData?.isSpecialProject,
      isGovernmentBuilding: edcrData?.isGovernmentBuilding || applicationData?.isGovernmentBuilding,

      typeOfProject: edcrData?.typeOfProject || applicationData?.typeOfProject,

      plotSubdivided: edcrData?.plotSubdivided || applicationData?.plotSubdivided,

      plotNo: edcrData?.plotNo || applicationData?.plotNo,

      needCompounding: edcrData?.needCompounding || applicationData?.needCompounding,

      plotLeaseHold: edcrData?.plotLeaseHold || applicationData?.plotLeaseHold,

      isApprovedLayout: edcrData?.isApprovedLayout || applicationData?.isApprovedLayout,

      isSpecialGroundCoverage: edcrData?.isSpecialGroundCoverage || applicationData?.isSpecialGroundCoverage,

      isSpecialFAR: edcrData?.isSpecialFAR || applicationData?.isSpecialFAR,

      constructionType: edcrData?.constructionType || applicationData?.constructionType,

      layoutsanctionNumber: edcrData?.layoutsanctionNumber || applicationData?.layoutsanctionNumber,

      layoutsanctionDate: edcrData?.layoutsanctionDate || applicationData?.layoutsanctionDate,

      groundCoverage: edcrData?.groundCoverages || applicationData?.groundCoverage,

      far: edcrData?.fars || applicationData?.far,

      isSetbackRequired: edcrData?.isSetbackRequired || applicationData?.isSetbackRequired,

      setbackFronts: edcrData?.previousSetbackFront || applicationData?.setbackFronts,

      setbackRears: edcrData?.previousSetbackRear || applicationData?.setbackRears,

      setbackSide1: edcrData?.previousSetbackSide1 || applicationData?.setbackSide1,

      setbackSide2: edcrData?.previousSetbackSide2 || applicationData?.setbackSide2,

      zoneType: edcrData?.zoneType || applicationData?.zoneType,

      isMetroCity: edcrData?.isMetroCity || applicationData?.isMetroCity,

      subZoneType: edcrData?.subZoneType || applicationData?.subZoneType,

      primaryUse: edcrData?.primaryUse || applicationData?.primaryUse,

      activityProposed: edcrData?.activityProposed || applicationData?.activityProposed,

      communityParking: edcrData?.communityParking || applicationData?.communityParking,

      anyotherCondition: edcrData?.anyotherCondition || applicationData?.anyotherCondition,

      khasraNo: edcrData?.khasraNo || applicationData?.khasraNo,

      sectorNo: edcrData?.sectorNo || applicationData?.sectorNo,

      fastPASId: fastPasData?.land_Id || applicationData?.fastPASId,

      schemeType: fastPasData?.descriptionOfLand?.schemeType || applicationData?.schemeType,

      typeOfArea: fastPasData?.descriptionOfLand?.developmentArea || applicationData?.typeOfArea,

      latitude: fastPasData?.descriptionOfLand?.latitude || applicationData?.latitude,

      longitude: fastPasData?.descriptionOfLand?.longitude || applicationData?.longitude,
      latitude: fastPasData?.descriptionOfLand?.latitude || applicationData?.latitude,

      roadwidth: fastPasData?.descriptionOfLand?.roadWidths?.[0]?.value || applicationData?.roadwidth,

      approachRoadWidth: fastPasData?.descriptionOfLand?.approachRoadWidths?.[0]?.value || applicationData?.approachRoadWidth,

      khasraDetails: fastPasData?.khasraDetails || applicationData?.khasraDetails,
      scrutinyFlow: applicationData?.scrutinyFlow || (edcrData?.edcrNumber && "EDCR"),

      selectedCity: fastPasData?.selectedCity || applicationData?.selectedCity,

      selectedUnit: fastPasData?.selectedUnit || applicationData?.selectedUnit,

      schemeName: edcrData?.schemeName || fastPasData?.schemeName || applicationData?.schemeName,

      mapSubDetails: {
        ...applicationData?.mapSubDetails,
        ...edcrData?.mapSubDetails,
        proposalTypeFAR: edcrData?.mapSubDetails?.proposalTypeFAR || applicationData?.mapSubDetails?.proposalTypeFAR,
        landUseApprovalLetter: edcrData?.mapSubDetails?.landUseApprovalLetter || applicationData?.approvalLetterUrl || fastPasData?.approvalLetterUrl,
        fireFighting: edcrData?.mapSubDetails?.fireFighting || applicationData?.mapSubDetails?.fireFighting,
        prevFileNo:
          edcrData?.prevFileNo ||
          applicationData?.prevFileNo ||
          applicationData?.mapSubDetails?.prevFileNo ||
          edcrData?.mapSubDetails?.prevFileNo ||
          applicationData?.additionalDetails?.oldCaseApplicationNo ||
          null,
        sanctionValidityDate:
          edcrData?.sanctionValidityDate ||
          applicationData?.sanctionValidityDate ||
          applicationData?.mapSubDetails?.sanctionValidityDate ||
          edcrData?.mapSubDetails?.sanctionValidityDate ||
          null,
        sanctionValidityStartDate:
          edcrData?.sanctionValidityStartDate ||
          applicationData?.sanctionValidityStartDate ||
          applicationData?.mapSubDetails?.sanctionValidityStartDate ||
          edcrData?.mapSubDetails?.sanctionValidityStartDate ||
          null,
      },

      descriptionOfLand: fastPasData?.descriptionOfLand || applicationData?.descriptionOfLand,
      // drawingDetail: [...applicationData?.drawingDetail, { viewPdf: edcrData?.viewPdf }],
      landInfo: fastPasData?.landInfo || applicationData?.landInfo,
      shelterFee: planInformation?.shelterFee || applicationData?.shelterFee || null,
      performanceGuarantee: edcrData?.additionalProperties?.performanceGuarantee || applicationData?.performanceGuarantee || null,
    };
    console.log("applicationDataFromidisRescrutiny", applicationData);

    return { applicationData, isAppDataLoading };
  }
  if (id && !isSuccess) {
    return {
      applicationData: {},
      isAppDataLoading,
    };
  }

  // Create Application data object for create flow
  const applicationType = "FORM_MAP";
  const userInfo = Digit.UserService.getUser();
  const { documents } = useSelector((state) => state.form12);
  const [, applicationFlow] = useDepartmentSelector();

  const applicantName = toTitleCase(scrutinyDetails?.applicantName || planInformation?.applicantName);

  applicationData = {
    ...applicationData,
    tenantId,
    applicationNo: edcrData?.applicationNumber || null,
    applicationDate: edcrData?.applicationDate || null,
    applicationSubType: edcrData?.applicationSubType || null,
    occupancy: planInformation?.occupancy || null,
    edcrNumber: edcrData?.edcrNumber || null,
    totalBuildUpArea: planDetail?.virtualBuilding?.totalBuitUpArea,
    totalProposedArea: planDetail?.virtualBuilding?.totalProposedArea,
    totalExistingBuiltUpArea: planDetail?.virtualBuilding?.totalExistingBuiltUpArea,
    maximumPermissibleGroundCoverage: planDetail?.virtualBuilding?.totalCoverageArea?.toFixed(2) || null,
    typeofArea: toTitleCase(planInformation?.landUseZone),
    propertyType: toTitleCase(planInformation?.applicantPropertyType || planDetail?.planInfoProperties?.PROPERTY_TYPE),
    proposal: planInformation?.proposalSubmittedFor || edcrData?.proposal || null,
    revenueVillageMohal: planInformation?.mauza || null,
    khataNo: planInformation?.khataNo || null,
    khatauniNo: planInformation?.khatauniNo || null,
    plotArea: planInformation?.plotArea || planDetail?.plot?.area || 0,
    plotAreaDoc: edcrData?.plotAreaDoc,
    plotAreaPos: edcrData?.plotAreaPossession,
    siteAddress: edcrData?.landAddress,
    totalPlotArea: planInformation?.plotArea || 0,
    purchasableFar: planInformation?.purchasableFar || applicationData?.purchasableFar || null,
    compensatoryFAR: planInformation?.compensatoryFAR || applicationData?.compensatoryFAR || null,
    transferredLandArea: planInformation?.transferredLandArea || applicationData?.transferredLandArea || null,
    blocks: planDetail?.blocks || null,
    basicFAR: edcrData?.basicFAR || 0,
    purchasableFAR: edcrData?.purchasableFAR || 0,
    premiumFAR: edcrData?.premiumFAR || 0,
    noOfBlocks: planDetail?.blocks?.length || 0,
    //premiumFAR: planDetail?.virtualBuilding?.premiumFarArea || 0,
    demolitionArea: planInformation?.demolitionArea || null,
    parkingArea: planDetail?.parkingDetails?.overAllParkingArea || 0,
    parkingFloorNo: planDetail?.parkingDetails?.parkingFloorNo || 0,
    activeTab: Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0,
    riskType: edcrData?.riskType,
    //planDetail: planDetail,
    applicationType,
    department: applicationFlow,
    feeType: "ApplicationFee",
    tod: {
      orientDevelopment: null,
      convertedLandUseinTOD: null,
    },
    planReport: edcrData?.planReport,
    updatedDxfFile: edcrData?.updatedDxfFile,
    dxfFile: edcrData?.dxfFile,
    workflow: { action: "INITIATE", assignes: null },
    landInfo: {
      owners: null,
      address: {
        city: planInformation?.district,
        locality: { code: "Lucknow" },
        region: null,
        doorNo: null,
        areaType: scrutinyDetails?.areaType,
      },
      tenantId,
    },
    professionaldetails: {
      name: userInfo?.info?.name,
      mobileNumber: userInfo?.info?.mobileNumber,
      emailId: userInfo?.info?.emailId,
    },
    landAreaDetails: {
      city: scrutinyDetails?.city?.name || toTitleCase(planInformation?.correspondenceAddress?.district) || null,
      locality: {
        name: scrutinyDetails?.locality?.name || toTitleCase(planInformation?.correspondenceAddress?.tehsil) || null,
      },
      village: {
        name: scrutinyDetails?.village?.name || toTitleCase(planInformation?.correspondenceAddress?.town) || null,
      },
      areaType: scrutinyDetails?.areaType,
    },
    businessService: applicationData?.businessService || applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP",
    documents,
    additionalDocs: edcrData?.additionalProperties?.documents || [],
    viewPdf: edcrData?.viewPdf,
    viewPlanReport: edcrData?.viewPlanReport,
    natureOfConstruction: edcrData?.natureOfConstruction,
    proposalType: edcrData?.proposalType,
    sanctionDate: edcrData?.sanctionDate,
    sanctionNumber: edcrData?.sanctionNumber,
    noOfPlots: edcrData?.noOfPlots,
    plotNumbers: edcrData?.plotNumbers,
    district: edcrData?.district,
    sectorNoPlotNo: edcrData?.sectorNoPlotNo,
    tehsil: edcrData?.tehsil,
    revenueVillage: edcrData?.revenueVillage,
    landMark: edcrData?.landMark,
    schemeName: edcrData?.schemeName,
    buildingClassification: edcrData?.buildingClassification,
    otherbuildingClass: edcrData?.otherbuildingClass,
    planOn: edcrData?.planOn,
    buildingHeight: edcrData?.buildingHeight,
    projectType: edcrData?.projectType,
    isRevised: edcrData?.isRevised,
    prevFileNo:
      edcrData?.prevFileNo ||
      applicationData?.prevFileNo ||
      applicationData?.mapSubDetails?.prevFileNo ||
      applicationData?.additionalDetails?.oldCaseApplicationNo ||
      null,
    sanctionValidityDate:
      edcrData?.sanctionValidityDate ||
      applicationData?.sanctionValidityDate ||
      applicationData?.mapSubDetails?.sanctionValidityDate ||
      edcrData?.mapSubDetails?.sanctionValidityDate ||
      null,
    sanctionValidityStartDate:
      edcrData?.sanctionValidityStartDate ||
      applicationData?.sanctionValidityStartDate ||
      applicationData?.mapSubDetails?.sanctionValidityStartDate ||
      edcrData?.mapSubDetails?.sanctionValidityStartDate ||
      null,
    isSpecialProject: edcrData?.isSpecialProject,
    isGovernmentBuilding: edcrData?.isGovernmentBuilding,
    typeOfProject: edcrData?.typeOfProject,
    plotSubdivided: edcrData?.plotSubdivided,
    plotNo: edcrData?.plotNo,
    needCompounding: edcrData?.needCompounding,
    plotLeaseHold: edcrData?.plotLeaseHold,
    isApprovedLayout: edcrData?.isApprovedLayout,
    isSpecialGroundCoverage: edcrData?.isSpecialGroundCoverage,
    isSpecialFAR: edcrData?.isSpecialFAR,
    constructionType: edcrData?.constructionType,
    layoutsanctionNumber: edcrData?.layoutsanctionNumber,
    layoutsanctionDate: edcrData?.layoutsanctionDate,
    groundCoverage: edcrData?.groundCoverages,
    far: edcrData?.fars,
    isSetbackRequired: edcrData?.isSetbackRequired,
    setbackFronts: edcrData?.previousSetbackFront,
    setbackRears: edcrData?.previousSetbackRear,
    setbackSide1: edcrData?.previousSetbackSide1,
    setbackSide2: edcrData?.previousSetbackSide2,
    zoneType: edcrData?.zoneType,
    isMetroCity: edcrData?.isMetroCity,
    subZoneType: edcrData?.subZoneType,
    primaryUse: edcrData?.primaryUse,
    activityProposed: edcrData?.activityProposed,
    communityParking: edcrData?.communityParking,
    anyotherCondition: edcrData?.anyotherCondition,
    khasraNo: edcrData?.khasraNo,
    sectorNo: edcrData?.sectorNo,
    uiFlow: { flow: "Form12" },
    fastPASId: fastPasData?.land_Id,
    scrutinyFlow: applicationData?.scrutinyFlow || (edcrData?.edcrNumber && "EDCR"),
    // schemeType: fastPasData?.descriptionOfLand?.schemeType,
    typeOfArea: fastPasData?.descriptionOfLand?.developmentArea,
    latitude: fastPasData?.descriptionOfLand?.latitude,
    longitude: fastPasData?.descriptionOfLand?.longitude,
    roadwidth: fastPasData?.descriptionOfLand?.roadWidths?.[0]?.value,
    approachRoadWidth: fastPasData?.descriptionOfLand?.approachRoadWidths?.[0]?.value,
    khasraDetails: fastPasData?.khasraDetails,
    selectedCity: fastPasData?.selectedCity,
    selectedUnit: fastPasData?.selectedUnit,
    schemeName: edcrData?.schemeName || fastPasData?.schemeName,
    mapSubDetails: {
      ...applicationData?.mapSubDetails,
      ...edcrData?.mapSubDetails,
      proposalTypeFAR: edcrData?.mapSubDetails?.proposalTypeFAR || applicationData?.mapSubDetails?.proposalTypeFAR,
      landUseApprovalLetter: edcrData?.mapSubDetails?.landUseApprovalLetter || applicationData?.approvalLetterUrl || fastPasData?.approvalLetterUrl,
      fireFighting: edcrData?.mapSubDetails?.fireFighting || applicationData?.mapSubDetails?.fireFighting,
      prevFileNo:
        edcrData?.prevFileNo ||
        applicationData?.prevFileNo ||
        applicationData?.mapSubDetails?.prevFileNo ||
        edcrData?.mapSubDetails?.prevFileNo ||
        applicationData?.additionalDetails?.oldCaseApplicationNo ||
        null,
      sanctionValidityDate:
        edcrData?.sanctionValidityDate ||
        applicationData?.sanctionValidityDate ||
        applicationData?.mapSubDetails?.sanctionValidityDate ||
        edcrData?.mapSubDetails?.sanctionValidityDate ||
        null,
      sanctionValidityStartDate:
        edcrData?.sanctionValidityStartDate ||
        applicationData?.sanctionValidityStartDate ||
        applicationData?.mapSubDetails?.sanctionValidityStartDate ||
        edcrData?.mapSubDetails?.sanctionValidityStartDate ||
        null,
    },
    descriptionOfLand: {
      ...fastPasData?.descriptionOfLand,
      schemeType: fastPasData?.descriptionOfLand?.schemeType,
    },

    landInfo: fastPasData?.landInfo,
    shelterFee: planInformation?.shelterFee || applicationData?.shelterFee || null,
    performanceGuarantee: edcrData?.additionalProperties?.performanceGuarantee || applicationData?.performanceGuarantee || null,
  };
  console.log("applicationDataFromOriginal", applicationData);

  return { applicationData, isAppDataLoading: false };
};

export default getMapSubmissionData;
